import React from "react";
import {
  Avatar,
  Hidden,
  Button,
  ListItemText,
  Paper,
  Popper,
  Grow,
  MenuItem,
  MenuList,
  ClickAwayListener
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { TFASetup } from "./2FA.js";
import { Sessions } from "./ListSessions.js";
import Profile from "./ProfileModal.js";
import Typography from '@material-ui/core/Typography';
import Verification from "./VerificationModal.js";
import { ErrorMessageModal } from './DocDialogs'

const styles = theme => ({
  primary: {
    color: theme.palette.secondary.light
  },
  user:{
    textTransform: "lowercase",
    color: '#ffffffab'
  },
  avatar:{
    backgroundColor: theme.palette.secondary.main + '8c',
  }
});

class ProfileMenu extends React.Component {
  state = {
    open: false,
    isTFAOpen: false,
    isModalSessionsOpen: false,
    isModalProfileOpen: false,
    profileComplete: (this.props.info.temp_profile === 'true')? false : true,
    isModalVerificationOpen: false,
    showPlatformMessage : false
  };

  componentDidMount() {
    if(this.state.profileComplete === false){
      this.openProfileModal()
    }

      //si no se realiza la verificación se abre la modal
      if(this.props.info.verified === 'false'){
        this.openVerificationModal()
      }

  }

  handleMenu = event => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false, show_sessions: false });
  };

  closeTFA = () => {
    this.setState({ isTFAOpen: false });
  };

  openTFA = () => {
    this.setState({ isTFAOpen: true });
  };

  logout = () => {
    this.setState({ open: false });
    this.props.signout();
  };

  openSessionsModal = () => {
    this.setState({ isModalSessionsOpen: true})
  }

  closeSessionsModal = () => {
    this.setState({ isModalSessionsOpen: false})
  }

  openProfileModal = () => {
    this.setState({ isModalProfileOpen: true})
  }

  openVerificationModal= () => {
    this.setState({ isModalVerificationOpen: true})
  }

  closeProfileModal = () => {
    this.setState({ isModalProfileOpen: false})
  }

  closeVerificationModal = (op) => {
    this.setState({ isModalVerificationOpen: false})
    if(op === 'success'){
      this.props.unlockWindow();
    }
  }

  handlePlatformMessage = () =>{
    this.setState({ showPlatformMessage : !this.state.showPlatformMessage })
  }


  render() {
    if (!this.props.isAuth) return null;
    const { classes, isOpen, isAuth, allowTour, openTour, info } = this.props;
    const { open, isTFAOpen, isModalSessionsOpen, isModalProfileOpen, profileComplete, isModalVerificationOpen, showPlatformMessage } = this.state;
    const profile = {...info, profileComplete}
    return (
      <div style={{ float: "right" }} data-tut="profile">
        <Button
          onClick={this.handleMenu}
          buttonRef={node => {
            this.anchorEl = node;
          }}
        >
            <Avatar
              alt="avatar"
              className={classes.avatar}>{ info.short_name.slice(0, 2) }</Avatar>
          <Hidden smDown>
            <ListItemText
              disableTypography
              primary={info.short_name}
              className={classes.primary}
              secondary={
              <Typography component="span" className={classes.user}>
                {info.user}
              </Typography>
          }
            />
          </Hidden>
        </Button>
        <Popper open={open || isOpen} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps}>
              <Paper>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <MenuList data-tut="profile-options">
                    <MenuItem onClick={this.openProfileModal}>Mi perfil</MenuItem>
                    <TWOFA
                      can_create={info.can_create}
                      openTFA={this.openTFA}
                    />
                    <MenuItem onClick={this.openSessionsModal}>Historial de sesiones</MenuItem>
                    <Help
                      isAuth={isAuth}
                      allowTour={allowTour}
                      openTour={openTour}
                      can_create={info.can_create}
                      isDelegate={info.isDelegate}
                      />
                    <MenuItem onClick={this.logout}>Cerrar sesión</MenuItem>
                  </MenuList>
                 </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        <TFASetup onClose={this.closeTFA} open={isTFAOpen} />
        <Sessions onClose={this.closeSessionsModal} open={isModalSessionsOpen} params={info} />
        <Profile onClose={this.closeProfileModal} open={isModalProfileOpen} profile={profile}/>
        <Verification
          onClose={this.closeVerificationModal}
          open={isModalVerificationOpen}
          can_create={info.can_create}
          verified={info.verified}
          isDelegate={info.isDelegate}
          user={info.id}
          showPlatformMessage={this.handlePlatformMessage}/>
        <ErrorMessageModal
          open={showPlatformMessage}
          close={this.handlePlatformMessage}
          message={'Hemos detectado que estas utilizando, Mac con Firefox, te sugerimos cambiarte a Chrome para aprovechar al 100% los beneficios de la plataforma Gestor de Oficios'}/>
      </div>
    );
  }
}

const Help = props =>{
  const { isAuth, allowTour, openTour, can_create, isDelegate } = props;
  return(
    (isAuth && allowTour && (can_create === "true" || isDelegate === true))? <Hidden smDown><MenuItem onClick={openTour}>Ayuda</MenuItem></Hidden> : null
  )
}

const TWOFA = props =>{
  const { openTFA } = props;

  return(
    <Hidden smDown><MenuItem onClick={openTFA}>Verificación de dos pasos</MenuItem></Hidden>
  )
}

export default withStyles(styles, { withTheme: true })(ProfileMenu);



// WEBPACK FOOTER //
// ./src/components/ProfileMenu.js